/**
 * <nia-collection-grid>
 * Paginación por "cargar más" con la Section Rendering API, y el estado de
 * espera mientras la barra de herramientas filtra.
 */
class NiaCollectionGrid extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-nia-grid]');
    this.sectionId = this.dataset.sectionId;

    this.addEventListener('click', this.#onClick);
    document.addEventListener('nia:facets:start', this.#onBusy);
    document.addEventListener('nia:facets:end', this.#onIdle);
  }

  disconnectedCallback() {
    document.removeEventListener('nia:facets:start', this.#onBusy);
    document.removeEventListener('nia:facets:end', this.#onIdle);
  }

  #onBusy = () => this.list?.setAttribute('aria-busy', 'true');

  #onIdle = () => this.list?.removeAttribute('aria-busy');

  #onClick = (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-nia-grid-more]') : null;
    if (button instanceof HTMLButtonElement && !button.disabled) this.#loadMore(button);
  };

  /** @param {HTMLButtonElement} button */
  async #loadMore(button) {
    const next = button.dataset.next;
    if (!next) return;

    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Cargando…';

    try {
      const url = new URL(next, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`section_id respondió ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshList = doc.querySelector('[data-nia-grid]');
      const freshButton = doc.querySelector('[data-nia-grid-more]');

      if (freshList && this.list) {
        // El foco se lleva a la primera tarjeta nueva para no perder el sitio.
        const first = freshList.firstElementChild;
        this.list.append(...freshList.children);
        first?.querySelector('a')?.setAttribute('tabindex', '-1');
        first?.querySelector('a')?.focus?.();
      }

      if (freshButton instanceof HTMLElement && freshButton.dataset.next) {
        button.dataset.next = freshButton.dataset.next;
        button.disabled = false;
        button.textContent = label;
      } else {
        button.closest('.nia-grid__more')?.remove();
      }
    } catch (error) {
      console.warn('[nia-collection-grid] No se pudo cargar más, navegando:', error);
      window.location.assign(next);
    }
  }
}

if (!customElements.get('nia-collection-grid')) {
  customElements.define('nia-collection-grid', NiaCollectionGrid);
}
